// Mobile Nav Tabs Active State
document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.mm-tabs [role="tab"]');
    const panes = document.querySelectorAll('.mm-tab-pane');

    function activateTab(tab) {
        if (tab.getAttribute('aria-selected') === 'true') return;

        tabs.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
        });
        panes.forEach(p => p.classList.remove('active'));

        // Activate the selected tab and its pane
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');
        const targetPane = document.querySelector(tab.getAttribute('data-target'));
        if (targetPane) {
            targetPane.classList.add('active');
        }
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));

        // Keyboard: Enter/Space activate; Arrow keys move focus between tabs
        tab.addEventListener('keydown', function(e) {
            switch (e.key) {
                case 'Enter':
                case ' ':
                    e.preventDefault();
                    activateTab(tab);
                    break;
                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    tabs[(index + 1) % tabs.length].focus();
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    tabs[(index - 1 + tabs.length) % tabs.length].focus();
                    break;
                case 'Home':
                    e.preventDefault();
                    tabs[0].focus();
                    break;
                case 'End':
                    e.preventDefault();
                    tabs[tabs.length - 1].focus();
                    break;
            }
        });
    });
});